/**
 * HL7 bundle files are registered as `text` but hold a JSON envelope, so the declared type alone
 * can't decide whether to render a tree.
 */
export function parseJsonDocument(content: string): object | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
    return null;
  }

  try {
    const parsed: unknown = JSON.parse(trimmed);
    return typeof parsed === "object" && parsed !== null ? parsed : null;
  } catch {
    return null;
  }
}
